import { laptopMediumMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

const MOB_BREAKPOINT = 1339;

export const Container = styled.div`
  display: flex;
  padding: 0 20px;
  margin: 30px 0;
  gap: 30px;

  @media (${laptopMediumMax}) {
    padding: 0 15px;
  }

  @media (${mobileXXLargeMax}) {
    padding: 0;
  }

  @media (max-width: ${MOB_BREAKPOINT}px) {
    flex-direction: column;
  }
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 30px;
  flex: 0 0 970px;
  max-width: 970px;
  list-style: none;
  padding: 0;
  margin: 0;

  @media (max-width: ${MOB_BREAKPOINT}px) {
    flex: 1;
    max-width: 100%;
  }
`;

export const HandyTools = styled.div`
  display: flex;
  flex: 1;
  max-width: 300px;
  min-width: 300px;
  flex-direction: column;
  gap: 30px;

  @media (max-width: ${MOB_BREAKPOINT}px) {
    max-width: none;
  }
`;

export const DesktopOnly = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  @media (max-width: ${MOB_BREAKPOINT}px) {
    display: none;
  }
`;

export const StickyBox = styled.div`
  position: sticky;
  top: 15px;
  left: 0;
`;

export const InfoBox = styled.div`
  width: 100%;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: stretch;

  button,
  a {
    display: block;
    font-size: 16px;
    color: ${({ theme }) => theme.textDark};
    text-align: left;

    &:hover {
      text-decoration: underline;
    }
  }

  svg {
    vertical-align: bottom;
  }
`;

export const AdContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InfoHeader = styled.h3`
  margin: -20px -20px 0 -20px;
  padding: 20px;
  color: ${({ theme }) => theme.textDark};
  border-bottom: 1px solid ${({ theme }) => theme.backgroundLighter};
`;

export const RecentSearchButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 5px;

  h4 {
    font-size: 16px;
  }

  p {
    font-size: 14px;
  }

  svg {
    margin-top: 2px;
  }
`;

export const MobileOnly = styled.div`
  display: block;

  @media (min-width: ${MOB_BREAKPOINT + 1}px) {
    display: none;
  }
`;
